export const masthead = () => {
    const advanceArrow = document.querySelector('.masthead--advance-arrow');
    if (advanceArrow) {
        advanceArrow.addEventListener('click', function (e) {
            e.preventDefault();
            const masthead = this.closest('.masthead');
            const nextGroup = masthead.nextElementSibling;
            if (nextGroup && nextGroup.classList.contains('wp-block-group')) {
                const elOffsetTop = nextGroup.offsetTop;
                window.scrollTo({
                    top: elOffsetTop,
                    behavior: 'smooth'
                });
            }
        });
    }

}
